import clsx from "clsx";

type HeadingProps = {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
} & React.ComponentPropsWithoutRef<"h1" | "h2" | "h3" | "h4" | "h5" | "h6">;

export function Heading({ className, level = 1, ...props }: HeadingProps) {
  let Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        "font-display text-gallery-900 dark:text-white tracking-tight",
        level === 1 && "text-2xl sm:text-3xl",
        level === 2 && "text-xl sm:text-2xl",
        level === 3 && "text-lg sm:text-xl",
        level === 4 && "text-base sm:text-lg",
        level === 5 && "text-sm sm:text-base",
        level === 6 && "text-sm",
      )}
    />
  );
}

export function Subheading({ className, level = 2, ...props }: HeadingProps) {
  let Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        "font-medium text-gallery-800 sm:text-sm dark:text-white tracking-tight",
      )}
    />
  );
}
